import React, { useState } from "react";

function Footer() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email) {
      setMessage("Please enter an email.");
      return;
    }

    try {
      const response = await fetch("http://127.0.0.1:8000/api/subscribe", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setMessage("Subscribed successfully!");
        setEmail(""); // clear input
      } else if (response.status === 409) {
        setMessage("You are already subscribed.");
      } else {
        setMessage(data.message || "Something went wrong.");
      }
    } catch (error) {
      setMessage("Server error. Please try again later.");
    }
  };

  return (
    <>
      <section style={styles.subscribeSection}>
        <h5 style={styles.subscribeTitle}>Subscribe to our Newsletter</h5>
        <form onSubmit={handleSubscribe} style={styles.form}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
          />
          <button type="submit" style={styles.button}>
            Subscribe
          </button>
        </form>
        {message && <p style={{ color: "#fff", marginTop: "10px" }}>{message}</p>}
      </section>

      <footer style={styles.footer}>
        <p>© {new Date().getFullYear()} My Website. All Rights Reserved.</p>
      </footer>
    </>
  );
}
const styles = {
  subscribeSection: {
    backgroundColor: "#032d57ff",
    padding: "30px 15px",
    textAlign: "center",
  },
  subscribeTitle: {
    marginBottom: "15px",
    color: "#f0f3f7ff",
  },
  form: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "10px",
  },
  input: {
    padding: "10px",
    width: "250px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  },
  button: {
    padding: "10px 20px",
    backgroundColor: "#343a40",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  footer: {
    backgroundColor: "#343a40",
    color: "white",
    textAlign: "center",
    padding: "15px",
    marginTop: "0",
    width: "100%",
  },
};

export default Footer;
